import { Omit, Partial } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { ConnectedAccountCharge } from './connected-account.charge.entity';

export class UpdateConnectedAccountChargeDto extends Partial(
    Omit(ConnectedAccountCharge, [...BaseEntityFieldsArray, 'providerType', 'providerId']),
) {}
